<template>
<section>
  <RecruitNav />
  <main>
    <h1 class="title">退会について</h1>
    <div class="withdrawal-msg">
      <section class="section1">
        退会いただくと全ての会員向けサービスをご利用いただけなくなります。<br>
        退会いただく場合は下記メールアドレスに退会申請メールをご送信の程よろしくお願いいたします。
      </section>
      <section class="section2">
        <p>送付先アドレス: support@hr-monster.io</p>
      </section>
      <section class="section3">
        <p>件名:「HRモンスター退会申請」と入力。</p>
        <p>本文:「ユーザー名」と「退会理由」を入力。</p>
      </section>
      <section class="section4">
        <p>※退会手続きの完了まで数日お時間をいただく場合がございます。</p>
      </section>
    </div>
  </main>
</section>
</template>

<script>
import RecruitNav from '@/views/Recruit/RecruitNav'

export default {
  name: 'Withdrawal',
  components: {
    RecruitNav
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
main {
  padding: 40px 0;
}
.title {
  font-size: 24px;
  font-weight: bold;
}
.withdrawal-msg {
  width: 50%;
  border: 1px solid #9e9e9e;
  margin: auto;
  padding: 24px;
  text-align: left;
}
.section1 {
  margin-bottom: 24px;
}
.section2 {
  margin-bottom: 24px;
  p {
    font-weight: bold;
  }
}
.section3 {
  margin-bottom: 24px;
  p {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Recruit/Withdrawal.vue